import * as form from '../form';

export const legalAssociationsTerrorismAdvocacy = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Why: form.textarea(xitem.Why),
        When: form.daterange(xitem.When),
        What: form.textarea(xitem.What),
      },
    };
  });
  return {
    HasTerrorismAdvocacy: form.branch(data.HasTerrorismAdvocacy),
    List: form.collection(items, (data.List || {}).branch),
  };
};
